import { isNil } from 'ramda';

/**
 * Утилита для получения корректного склонения слова "предложений"
 * */
export const getDeclension = (count: number | null) => {
  if (isNil(count)) {
    return `{0} предложений`;
  }

  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastDigit === 1 && lastTwoDigits !== 11) {
    return `${count} предложение`;
  } else if ([2, 3, 4].includes(lastDigit) && ![12, 13, 14].includes(lastTwoDigits)) {
    return `${count} предложения`;
  } else {
    return `${count} предложений`;
  }
};
